import React from 'react';
import { PanelLeft } from 'lucide-react';
import { useLocale } from '../contexts/LocaleContext';
import { useSidebar } from './ui/sidebar';
import { useIsMobile } from '../hooks/use-mobile';

export const SidebarToggleButton: React.FC = () => {
  const { t } = useLocale();
  const isMobile = useIsMobile();
  let sidebar;
  try {
    sidebar = useSidebar();
  } catch {
    return null;
  }

  if (!isMobile) {
    return null;
  }

  return (
    <button
      onClick={sidebar.toggleSidebar}
      className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md text-foreground"
      style={{
        backgroundColor: 'transparent',
        border: 'none',
        cursor: 'pointer',
      }}
      aria-label={t('toggle_sidebar')}
      title={t('toggle_sidebar')}
    >
      <PanelLeft className="h-4 w-4" />
    </button>
  );
};
